import {
    MANAGEMENT_UPDATE_SELECTED_ROW
} from './actionTypes';

export function setSelectedRows(rows) {
    return {
        type: MANAGEMENT_UPDATE_SELECTED_ROW,
        rows
    }
}